import request from '@/utils/request'

/*
data: Form Data
*/
export function uploadImage(data) {
  return request({
    url: '/jwt/my-photo/add',
    method: 'post',
    data
  })
}

export function listImages(data) {
  return request({
    url: '/jwt/my-photo/list',
    method: 'post',
    data
  })
}

export function removeImages(data) {
  return request({
    url: '/jwt/my-photo/remove',
    method: 'post',
    data
  })
}
